// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:5qGIDv */\n.bhSxv{align-items:center;color:var(--audio-content-primary);display:inline-flex;font-family:var(--font-muse-sans);gap:var(--audio-spacing-4);justify-content:center;padding-right:var(--audio-spacing-4)}.ZVKSd{font-size:var(--audio-font-size-13);font-weight:400;height:1rem;letter-spacing:.01875rem;line-height:var(--audio-line-height-16)}.ZVKSd .kpY-B{height:1rem;width:1rem}.ho3Iy{font-size:var(--audio-font-size-15);font-weight:400;height:1.375rem;line-height:var(--audio-line-height-20)}.ho3Iy .kpY-B{height:1.25rem;width:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"counter": "bhSxv",
	"size-small": "ZVKSd",
	"icon": "kpY-B",
	"size-large": "ho3Iy"
};
export default ___CSS_LOADER_EXPORT___;
